export const tr = {
    apply: 'Uygula',
    create: 'oluştur',
    'create-from-preset': 'Yenisini oluştururken baz al',
    'creative-remove-confirm-description': 'Banner setini silmek istediğinize emin misiniz?',
    edit: 'Düzenle',
    'no-creatives': 'Kreatif yok',
    'no-creatives-but-can-create': 'Bu alan şimdilik boş; bir şeyler {presetsLink} tam zamanı',
    select: 'Seç',
    selected: '{selected} / {total} adedi seçildi',
    'selected-banner-sizes': "Şu boyutlarda banner'lar içeren kreatifler gösterildi: {sizes} ",
    view: 'Görüntüle'
};
